/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { sendRequest } from '@msdyn365-commerce/core';

/**
 * Sets an encrypted cookie via the rendering service endpoint.
 * @param origin - The origin URL (e.g., window.location.origin).
 * @param cookieKey - The cookie key to set.
 * @param cookieValue - The cookie value to set.
 * @returns A promise that resolves when the cookie has been set.
 */
export function setRenderingServiceCookie(origin: string, cookieKey: string, cookieValue: string): Promise<void> {
    const body = { cookieKey, cookieValue };
    const options = {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    };
    return sendRequest(`${origin}/onerf/cookie`, 'post', body, options).then(() => undefined);
}
